import React, { useState } from 'react';

import { ReactComponent as Arrow } from 'assets/icons/ic_arrow.svg';
import { UNIV_LIST } from 'shared/constants';
import { useRouteChangeHandler } from 'shared/hooks';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import SlideCard from './SlideCard';

export type univItem = {
  title: string;
  url: string;
  banner: string;
  card: string;
  link: string;
};

const HomeSlider = () => {
  const { handleRouteChange } = useRouteChangeHandler();
  const [swiper, setSwiper] = useState<SwiperClass>();

  const handlePrev = () => {
    swiper?.slidePrev();
  };

  const handleNext = () => {
    swiper?.slideNext();
  };

  const handleClick = (title: string, idx: number) => {
    const formattedTitle = title.replace(/\n/g, '');
    window.dataLayer?.push({
      event: 'click_main_univ_card',
      title: formattedTitle,
      index: idx,
    });
    handleRouteChange(`/listing${UNIV_LIST[idx].url}`);
  };

  return (
    <div className="flex w-full max-w-[1440px] items-center justify-between px-6">
      <button onClick={handlePrev} className="flex shrink-0 items-center justify-center">
        <Arrow width={48} height={48} className="rotate-180 text-[#BBBBBB]" />
      </button>
      <div className="w-[calc(100%-208px)]">
        <Swiper modules={[Navigation]} slidesPerView={4} spaceBetween={28} onSwiper={(swiper) => setSwiper(swiper)}>
          {UNIV_LIST.map((univ, idx) => (
            <SwiperSlide key={idx}>
              <SlideCard title={univ.title} onClick={() => handleClick(univ.title, idx)} src={univ.card} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button onClick={handleNext} className="flex shrink-0 items-center justify-center">
        <Arrow width={48} height={48} className="text-[#BBBBBB]" />
      </button>
    </div>
  );
};

export default HomeSlider;
